export const common = {
    api: {
        authentication: {
            clientKey: 'ck_d08baa3e52936cdde43c7980fe2e95b31cdab5d4',
            clientSecret: 'cs_abcbd947065e5899162eb13681c3237e158e0f1d'
        },
        json: { 
            wc: window.location.protocol + '//' + window.location.hostname + '/wp-json/wc/v3/',
            cocart: window.location.protocol + '//' + window.location.hostname + '/wp-json/cocart/v1/',
            wp: window.location.protocol + '//' + window.location.hostname + '/wp-json/wp/v2/'
        }
    }
}
